import { gql } from '@apollo/client'

export const GET_DEPARTMENTS = gql`
  query departments($term: String) {
    departments(term: $term) {
      id
      name
    }
  }
`
